<template>
  <div id="app">
    <transition mode="out-in" name="fade">
      <keep-alive>
        <router-view></router-view>
      </keep-alive>
    </transition>
  </div>
</template>

<script>

export default {
  data() {
    return {

    }
  },
  created() {
    this.getVersionUpdate()// 版本更新检测
  },
  methods: {
    getVersionUpdate() {
      // 版本更新检测
      if (process.env.version) {
        const version = process.env.version;  //版本号（每次上线前需要更新下版本号）
        const clientVersion = localStorage.getItem('_version_')//本地版本号
        const clientVersionTime = localStorage.getItem('_version_time')//网站已更新标志

        if (clientVersionTime && Number(clientVersionTime) === 1) {
          localStorage.removeItem('_version_time')//移除网站更新标志
          this.$message({
            message: '网站已更新！',
            type: 'success'
          });
        }

        if (!clientVersion) {
          // 第一次登录网站，保存版本号
          localStorage.setItem('_version_', version)
        } else if (clientVersion !== version + '') {
          this.$confirm('网站有新版本，是否立即更新？', '更新提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning',
            center: true
          }).then(() => {
            //刷新网站
            localStorage.setItem('_version_time', 1)//保存网站是否已进行更新
            localStorage.setItem('_version_', version)//保存新的版本号
            window.location.reload(true)//不走缓存刷新网站
          }).catch(() => {
            //取消刷新
          });
        }
      }
    }
  }
}
</script>

<style lang="less">
#app {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}
#nav {
  padding: 30px;
  a {
    font-weight: bold;
    color: #2c3e50;
    &.router-link-exact-active {
      color: #42b983;
    }
  }
}
@import "./assets/style/font.css";
</style>
